import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  Typography,
  IconButton
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { getDisplayAddress } from './utils/utils';
import {consoleDevLog} from "../apiConfig";

const CompareModal = ({
  subjectProperty,
  comparableHome,
  open,
  onClose,
  comparisonFields,
  adjustments
}) => {

  // Same color comparison logic as before
  const getComparisonColor = (subjectValue, comparableValue, isHigherBetter = true) => {
    // Convert values to numeric if possible; otherwise default to 0
    const sVal = Number(subjectValue) || 0;
    const cVal = Number(comparableValue) || 0;

    if (sVal === cVal) return "gray";
    if ((isHigherBetter && cVal > sVal) || (!isHigherBetter && cVal < sVal)) {
      return "green";
    }
    return "red";
  };

  const getLotSize = (property) => {
    return property.Front_ft && property.Depth
      ? Math.round(property.Front_ft * property.Depth)
      : null;
  };

  const getPropertyValue = (property, key) => {
    return property[key] ?? "N/A";
  };
  const subjectLotSize = getLotSize(subjectProperty);
  const comparableLotSize = getLotSize(comparableHome);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle style={{paddingBottom: "0px"}}>
        <p style={{textAlign: "center"}}>Compare Properties</p>
        <IconButton
          onClick={onClose}
          style={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{fontSize: "1rem"}}><strong>Feature</strong></TableCell>
              <TableCell style={{fontSize: "1rem"}}><strong>Subject Property</strong></TableCell>
              <TableCell style={{fontSize: "1rem"}}><strong>Comparable Home</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {comparisonFields.map(({ label, key, isHigherBetter }) => {
              let subjectValue, comparableValue, comparisonColor;
              
              if (key === "Address") {
                // Handle Address field specially
                subjectValue = getDisplayAddress(subjectProperty);
                comparableValue = getDisplayAddress(comparableHome);
                comparisonColor = "black"; // No color coding for addresses
              } else if (key === "LotSize") {
                // Handle LotSize field as before
                subjectValue = subjectLotSize !== null ? `${subjectLotSize} sqft` : "N/A";
                comparableValue = comparableLotSize !== null ? `${comparableLotSize} sqft` : "N/A";
                comparisonColor = getComparisonColor(subjectLotSize, comparableLotSize, isHigherBetter);
              } else {
                // Handle all other fields as before
                subjectValue = getPropertyValue(subjectProperty, key);
                comparableValue = getPropertyValue(comparableHome, key);
                comparisonColor = getComparisonColor(subjectValue, comparableValue, isHigherBetter);
              }

              return (
                <TableRow key={key}>
                  <TableCell style={{fontSize: "1rem"}}>{label}</TableCell>
                  <TableCell style={{fontSize: "1rem"}}>{subjectValue}</TableCell>
                  <TableCell style={{ color: comparisonColor, fontSize: "1rem" }}>
                    {comparableValue}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>

        {/* ===================== 2) Price Adjustments ===================== */}
        {adjustments && adjustments.length > 0 && (
          <>
            <Typography variant="h6" gutterBottom style={{ marginTop: 16, textAlign: "center", marginBottom: 0 }}>
              Price Adjustments
            </Typography>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{fontSize: "1rem"}}><strong>Adjustment</strong></TableCell>
                  <TableCell style={{fontSize: "1rem"}}><strong>Subject Property</strong></TableCell>
                  <TableCell style={{fontSize: "1rem"}}><strong>Comparable Home</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {adjustments.map((adj, idx) => {
                  // For the label in this row, we can use "adj.englishName" or "adj.description".
                  // This example uses "adj.englishName".
                  const label = adj.englishName ?? adj.description ?? "Adjustment";
                  // We use "adj.rawAttribute" to get the actual property values from each home
                  const subjectVal = subjectProperty[adj.rawAttribute] ?? "N/A";
                  const compVal = comparableHome[adj.rawAttribute] ?? "N/A";

                  // Optionally: if you have a known "isHigherBetter" for each adjustment, use it:
                  // Otherwise, default to true or false.
                  const comparisonColor = getComparisonColor(subjectVal, compVal, true);

                  return (
                    <TableRow key={idx}>
                      <TableCell style={{fontSize: "1rem"}}>{label}</TableCell>
                      <TableCell style={{fontSize: "1rem"}}>{subjectVal}</TableCell>
                      <TableCell style={{ color: comparisonColor, fontSize: "1rem" }}>
                        {compVal}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </>
        )}

      </DialogContent>
    </Dialog>
  );
};

export default CompareModal;
